import IForgotPassword from "../../models/IForgotPassword";

export const initialState: IForgotPassword = {
    email: "",
}
